import React from "react"

import Image from "@atoms/Image/Image"

import styles from "./Logos.module.scss"

const Logos = ({ logos }) => {
  return logos?.length > 0 ? (
    <section className={styles.element}>
      <div
        className={`${styles.grid} ${logos.length === 6 ? styles.grid6 : ""} ${
          logos.length > 6 ? styles.evenly : ""
        }`}
      >
        {logos.map((item, index) => {
          const { logo } = item
          const { mediaDetails } = logo || {}
          const { width, height } = mediaDetails || {}

          const aspectRatio = width && height ? width / height : 1

          const shape =
            aspectRatio > 2
              ? "verywide"
              : aspectRatio > 1.6
              ? "wide"
              : "regular"

          return (
            <div key={index} className={styles.item}>
              <div className={styles[shape]}>
                <Image image={logo} widths={[256]} />
              </div>
            </div>
          )
        })}
      </div>
    </section>
  ) : (
    ""
  )
}

export default Logos
